import { GridLocaleText, deDE, enUS, frFR, nlNL } from '@mui/x-data-grid-pro'
import { useTranslation } from 'react-i18next'

function mapI18nLanguageToDataGridLocaleText(locale: string): Partial<GridLocaleText> {
  switch (locale) {
    case 'nl-NL':
    case 'nl-BE':
      return nlNL.components.MuiDataGrid.defaultProps.localeText
    case 'fr-FR':
    case 'fr-BE':
      return frFR.components.MuiDataGrid.defaultProps.localeText
    case 'de-DE':
      return deDE.components.MuiDataGrid.defaultProps.localeText
    default:
      return enUS.components.MuiDataGrid.defaultProps.localeText
  }
}

/**
 * This hook returns localized texts for the data grid.
 *
 * It can allow us to use our own translations by changing the returned object.
 * The properties declared in the GridLocaleText interface are the available keys.
 * It uses the translations provided by MUI for now.
 */
export function useDataGridLocaleText(): Partial<GridLocaleText> {
  const { i18n, t } = useTranslation()

  const localeText = mapI18nLanguageToDataGridLocaleText(i18n.language)

  return {
    ...localeText,
    gridActionsCellDeleteItemTooltip: t('DataGrid.GridActionsCellItem.DeleteText'),
    gridActionsCellEditItemTooltip: t('DataGrid.GridActionsCellItem.EditText'),
    resetColumnsButton: t('DataGrid.ResetColumnsButton'),
    resetFiltersButton: t('DataGrid.ResetFiltersButton'),
    resetSortingButton: t('DataGrid.ResetSortingButton'),
    toolbarExport: t('DataGrid.Toolbar.Export'),
    toolbarExportTitle: t('DataGrid.Toolbar.ExportTitle'),
    toolbarExportSearchLabel: t('DataGrid.Toolbar.ExportSearchLabel'),
    toolbarExportDeselectAllButton: t('DataGrid.Toolbar.ExportDeselectAllButton'),
    toolbarExportSelectAllButton: t('DataGrid.Toolbar.ExportSelectAllButton'),
    toolbarExportSelectVisibleButton: t('DataGrid.Toolbar.ExportSelectVisibleButton'),
    toolbarExportCancelButton: t('DataGrid.Toolbar.ExportCancelButton'),
    toolbarExportCSVButton: t('DataGrid.Toolbar.ExportCSVButton'),
    toolbarExportExcelButton: t('DataGrid.Toolbar.ExportExcelButton'),
    toolbarExportColumnsToBeExported: (count: number) => t('DataGrid.Toolbar.ExportColumnsToBeExported', { count })
  }
}
